import React from "react";
import { Grid, Message } from "semantic-ui-react";
import { connect } from "react-redux";
import HomeHeader from "./HomeHeader";

const HomeError = ({ appName, inProgress }) => (
  <Grid stretched divided padded="horizontally" columns={2} textAlign="center">
    <Grid.Row>
      <HomeHeader />
    </Grid.Row>
    <Grid.Row>
      {!inProgress && (
        <Message negative>
          <Message.Header>Error</Message.Header>
          <p>An error has occurred. Please try again later!</p>
        </Message>
      )}
    </Grid.Row>
  </Grid>
);

const mapStateToProps = state => ({ ...state.common });

export default connect(mapStateToProps)(HomeError);
